import { Box, CssBaseline, Menu, MenuItem, Toolbar, Tooltip, useTheme } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt, faDownload, faQuestion, faUserTie } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { LuUtilityPole } from "react-icons/lu";
import { PiBlueprint } from "react-icons/pi";
import useStateRef from "react-usestateref";
import { Drawer, DrawerHeader, AppBar } from "../../components/Drawer/Drawer";
import "./style.css"
import DrawerButtonThatOpens from "../../components/Drawer/DrawerButton";
import { Navigate, Outlet, useNavigate, useOutlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout, setEmail } from "../../state/slices/userSlice";
import Abas from "../AbasWIP";
import { newTab, setTabFromNewIndex } from "../../state/slices/tabsSlice";
import { setImages } from "../../state/slices/imagesSlices";
import servLogin from "../../services/login/servLogin";
import servParam from "../../services/login/servParam";
import servTermoConsentimento from "../../services/login/servTermoConsentimento";
import Popup from "../../components/Popup";
import AlterarSenha from "./AlterarSenha";
import TermoConsentimento from "./TermoConsentimento";
import { LoadScript } from '@react-google-maps/api';
import { toggleSidebar } from "../../state/slices/sidebarSlice";
import { setChaveGD, setChaveCI } from "../../state/slices/mapaSlice";
import { setRn1095 } from "../../state/slices/ucSlice";

const HomeLayout = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const user = useSelector(state => state.user);
    const images = useSelector(state => state.images);
    const tabs = useSelector(state => state.tabs);
    const outlet = useOutlet();
    const dispatch = useDispatch();
    const open = useSelector(state => state.sidebar.sidebarOpen);
    const [disabled, setDisabled] = useState(false);
    const [aba, setAba] = useState(0);
    const [openAlterarSenha, setOpenAlterarSenha] = useState(false);
    const [openTermoConsentimento, setOpenTermoConsentimento] = useState(false);
    const [codigoTermo, setCodigoTermo] = useState(false);
    const [linkTermoConsentimento, setLinkTermoConsentimento] = useState('');
    const [logoA, setLogoA] = useState("");
    const [logoS, setLogoS] = useState("");
    const [usaTermoConsentimento, setUsaTermoConsentimento, usaTermoConsentimentoRef] = useStateRef(0);
    const [termoConsentimentoDoc, setTermoConsentimentoDoc, termoConsentimentoDocRef] = useStateRef(0);
    const [permissoes, setPermissoes] = useState([]);
    const [dataAceiteTermo, setDataAceiteTermo, dataAceiteTermoRef] = useStateRef(null);
    const [chaveApiGoogle, setChaveApiGoogle] = useState("");


    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const handleClickMenu = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleCloseMenu = () => {
        setAnchorEl(null);
    }

    useEffect(() => {
        if (!user.isAuthenticated) return;

        const recuperarImagens = async () => {
            try {

                const response = await servLogin.recuperarImages();

                dispatch(setImages(response));
    
                const urlAberta = response?.Content?.UrlLogoAberta?.trim();
                const urlFechada = response?.Content?.UrlLogoFechada?.trim();
    
                setLogoA(urlAberta && urlAberta !== "string" ? urlAberta : window.Use.config.logoAberta);
                setLogoS(urlFechada && urlFechada !== "string" ? urlFechada : window.Use.config.logoFechada);
            } catch (err) {
                console.log(err);
                setLogoA(window.Use.config.logoAberta);
                setLogoS(window.Use.config.logoFechada);
            }
        };
    
        recuperarImagens();

        const recuperarDadosPaginaLogin = async () => {
            try {
                const response = await servLogin.recuperarDadosPaginaLogin();
                const tituloSistema = document.getElementById("TituloSistema");
                const TituloAbaP3Tec = { tituloAba: response.Content.TituloAbaP3Tec };

                localStorage.setItem('TituloAbaP3Tec', JSON.stringify(TituloAbaP3Tec));

                if (TituloAbaP3Tec) {
                    const tituloAba = JSON.parse(localStorage.getItem('TituloAbaP3Tec')).tituloAba;
                    tituloSistema.textContent = tituloAba + " P3 Tec";
                }
            } catch (err) {
                console.log("erro" + err);
            }
        }

        const recuperarParametros = async () => {
            try {
                const params = await servParam.recuperarRespTecnicoParametros().catch(err => {
                    console.warn("Falha ao recuperar parâmetros técnicos:", err);
                    return { Content: {} };
                });

                const paramsGd = await servParam.recuperarGDParametros().catch(err => {
                    console.warn("Módulo GD não configurado ou inexistente.");
                    return { Content: { ChaveGoogle: "", Rn1095: "" } };
                });

                const paramsCi = await servParam.recuperarCIParametros().catch(err => {
                    console.warn("Módulo CI não configurado ou inexistente.");
                    return { Content: { ChaveGoogle: "" } };
                });

                const keyGd = paramsGd?.Content?.ChaveGoogle || "";
                const keyCi = paramsCi?.Content?.ChaveGoogle || "";

                dispatch(setChaveGD(keyGd));
                dispatch(setChaveCI(keyCi));

                if (paramsGd?.Content?.Rn1095) {
                    dispatch(setRn1095(paramsGd.Content.Rn1095));
                }

                const chaveFinal = keyGd || keyCi;
                setChaveApiGoogle(chaveFinal);

                setUsaTermoConsentimento(params.Content.UsaTermoConsentimento);
                setTermoConsentimentoDoc(params.Content.TermoConsentimentoDoc);

                if (usaTermoConsentimentoRef.current) {
                    const termoConsentimento = await servParam.recuperarTermoConsentimento();
                    setLinkTermoConsentimento('data:application/pdf;base64,' + termoConsentimento.Content.Arquivo);
                }
            } catch (err) {
                console.log("erro" + err);
            }
        };

        const recuperarPermissaoModulo = async () => {
            try {
                const response = await servLogin.permissoesModulos();
                setPermissoes(response.Content);
            } catch (err) {
                dispatch(logout());
                navigate("/login", { replace: true });
            }
        }

        const recuperarTermoConsentimento = async () => {
            try {
                let filtrosTermos = `page=1&start=0&limit=1&fields=["Id", "CodigoResponsavel", "DataAceite", "Aceito", "TermoConsentimentoDoc"]]&sort=[{"property":"DataAceite","direction":"DESC"}]&filter=[{"property":"CodigoResponsavel","operator":"equal","value":"${user.codigoUsuario}","and":true,"not":false}]`;

                const responseTermo = await servTermoConsentimento.recuperarTermos(filtrosTermos);
                let termo = responseTermo.Content;

                if (user.email) {
                    const respTecnico = await servLogin.consultaAnaliseResponsavel(user.codigoUsuario);

                    dispatch(setEmail(respTecnico.Content));
                }

                if (user.situacao !== 3) setDisabled(true);

                if (usaTermoConsentimentoRef.current) {
                    if (Object.keys(termo).length === 0) {
                        setDisabled(true);
                        setOpenTermoConsentimento(true);
                        setCodigoTermo(0);
                    } else if (termo[0].TermoConsentimentoDoc !== termoConsentimentoDocRef.current) {
                        setDisabled(true);
                        setOpenTermoConsentimento(true);
                        setCodigoTermo(termo[0].Id);
                    } else {
                        setDataAceiteTermo(termo[0].DataAceite);
                    }
                }
            } catch (err) {
                console.log(err);
            }
        }

        if (!user.isAuthenticated) return;

        const inicializarHome = async () => {
            try {
                await Promise.all([
                    recuperarImagens(),
                    recuperarDadosPaginaLogin(),
                    recuperarParametros(),
                    recuperarPermissaoModulo()
                ]);

                await recuperarTermoConsentimento();
            } catch (error) {
                console.error("Erro na inicialização:", error);
            }
        };

        inicializarHome();
    }, [user.isAuthenticated]);

    if (!user.isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    const handleClickManual = () => {
        window.open('https://manuaisp3tec.useallcloud.com.br/', '_blank', 'noopener,noreferrer');
    }

    const handleDrawer = () => {
        dispatch(toggleSidebar());
    }

    const onClickLogout = (e) => {
        dispatch(logout());
    }

    const onClickAbrirGeracaoDistribuida = () => {
        dispatch(newTab({
            Nome: "Geração distribuída",
            Aba: 7
        }));

        dispatch(setTabFromNewIndex(7));
    }

    const onClickAbrirCompInfraestrutura = () => {
        dispatch(newTab({
            Nome: "Compartilhamento de infraestrutura",
            Aba: 8
        }));

        dispatch(setTabFromNewIndex(8));
    }

    const onClickAbrirProjetosParticulares = () => {
        dispatch(newTab({
            Nome: "Projetos particulares",
            Aba: 16
        }));

        dispatch(setTabFromNewIndex(16));
    }

    const onClickAbrirDownloads = () => {
        dispatch(newTab({
            Nome: "Normas técnicas",
            Aba: 15
        }));

        dispatch(setTabFromNewIndex(15));
    }

    const handleTrocaDeAba = (evento, novaAba) => {
        setAba(novaAba);
    }

    const onClickAlterarSenha = () => {
        setOpenAlterarSenha(true);
    }

    const abrirTermos = async () => {
        const r = await fetch(linkTermoConsentimento);
        const blob = await r.blob();
        window.open(URL.createObjectURL(blob));
    }

    return (
        <div style={{ height: "auto" }}>
            {chaveApiGoogle && chaveApiGoogle.length > 10 ? (<LoadScript googleMapsApiKey={chaveApiGoogle} libraries={["places", "drawing"]} version="3.64"/>) : null}
            <CssBaseline />
            <AppBar position="fixed" open={open}>
                <Toolbar sx={{ marginLeft: open ? "0px" : "50px", justifyContent: "space-between", height: "10px" }}>
                    <Abas />
                    <div className="dropdown">
                        {user && (
                            <span>{user.name}</span>
                        )}
                        <button
                            aria-haspopup="true"
                            className="avatarButton"
                            onClick={handleClickMenu}
                        >
                            <FontAwesomeIcon icon={faUserTie} size="2x" />
                        </button>
                        <Menu
                            open={openMenu}
                            sx={{
                                "& .MuiPaper-root": {
                                    backgroundColor: "#494949",
                                    color: "white"
                                }
                            }}
                            anchorEl={anchorEl}
                            onClose={handleCloseMenu}
                        >
                            <MenuItem onClick={abrirTermos} style={usaTermoConsentimentoRef.current ? {} : { display: "none" }}>
                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "start" }}>
                                    <span>Visualizar Termos de consentimento</span>
                                    <span style={dataAceiteTermoRef.current ? { fontSize: "0.7em" } : { display: "none" }}>Aceito em: {dataAceiteTermoRef.current}</span>
                                </div>


                            </MenuItem>
                            <MenuItem onClick={onClickAlterarSenha}>Alterar senha</MenuItem>
                            <MenuItem onClick={onClickLogout} >Logout</MenuItem>
                        </Menu>
                        <button
                            aria-haspopup="true"
                            className="avatarButton"
                            onClick={handleClickManual}
                        >
                            <Tooltip title="Manual do sistema">
                                <FontAwesomeIcon icon={faQuestion} size="2x" />
                            </Tooltip>
                        </button>
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer open={open} variant="permanent">
                <DrawerHeader>
                    <div style={{ width: open ? "250px" : `calc(${theme.spacing(8)} + 1px)` }} className="drawerLogo">
                        <div className={
                            open ? "logoFull" : "logoShort"
                        }>
                            <img src={open ? logoA : logoS} alt="Logo cooperativa" />
                        </div>
                    </div>
                </DrawerHeader>
                <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", gap: "10px", padding: "9px" }}>
                    <DrawerButtonThatOpens onClick={handleDrawer} open={open} name="" disabled={disabled}>
                        <MenuIcon />
                    </DrawerButtonThatOpens>

                    {
                        permissoes?.GeracaoDistribuida &&
                        <DrawerButtonThatOpens onClick={onClickAbrirGeracaoDistribuida} open={open} name="Geração distribuída" disabled={disabled} style={{ justifyContent: open ? 'start' : 'center', gap: '18px' }}>
                            <FontAwesomeIcon icon={faBolt} />
                        </DrawerButtonThatOpens>
                    }

                    {
                        permissoes?.CompartilhamentoInfraestrutura &&
                        <DrawerButtonThatOpens onClick={onClickAbrirCompInfraestrutura} open={open} name="Comp. Infraestrutura" disabled={disabled} style={{ justifyContent: open ? 'start' : 'center', gap: '18px' }}>
                            <LuUtilityPole style={{ overflow: 'visible' }} />
                        </DrawerButtonThatOpens>
                    }

                    {
                        permissoes?.ProjetosParticulares &&
                        <DrawerButtonThatOpens onClick={onClickAbrirProjetosParticulares} open={open} name="Projetos particulares" disabled={disabled} style={{ justifyContent: open ? 'start' : 'center', gap: '18px' }}>
                            <PiBlueprint style={{ overflow: 'visible' }} />
                        </DrawerButtonThatOpens>
                    }

                    <DrawerButtonThatOpens onClick={onClickAbrirDownloads} open={open} name="Normas técnicas" style={{ justifyContent: open ? 'start' : 'center', gap: '18px' }}>
                        <FontAwesomeIcon icon={faDownload} />
                    </DrawerButtonThatOpens>
                </Box>
            </Drawer>
            <Popup title="Alterar senha" openPopup={openAlterarSenha} setOpenPopup={setOpenAlterarSenha} minHeight="100px">
                <AlterarSenha
                    setOpenPopup={setOpenAlterarSenha}
                />
            </Popup>
            <Popup title="Termos de consentimento" openPopup={openTermoConsentimento} setOpenPopup={setOpenTermoConsentimento} minHeight="100px" hiddenCloseBtn={true}>
                <TermoConsentimento
                    codigoTermo={codigoTermo}
                    linkTermoConsentimento={linkTermoConsentimento}
                    termoConsendimentoDoc={termoConsentimentoDocRef.current}
                    setOpenPopup={setOpenTermoConsentimento}
                    setDisableHome={setDisabled}
                />
            </Popup>
            <main style={{ margin: open ? "64px 0px 0px 250px" : "64px 0px 0px 64px", height: "calc(100vh - 64px)", width: open ? "calc(100vw - 250px)" : "calc(100vw - 64px)" }}>
                <Outlet />
            </main>
        </div>
    );
}

export { HomeLayout }